var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRingsInside = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 484.298 511.582"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 292",
  d: "M197.334 361.218a14.962 14.962 0 00-14.923 15v60.3a14.962 14.962 0 0014.923 15h30l10-45.151-10-45.151z",
  fill: "#f9f9f9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 293",
  d: "M257.326 361.218h-30v90.3h30a14.962 14.962 0 0014.923-15v-60.3a14.961 14.961 0 00-14.923-15z",
  fill: "#e7f0ef"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 56"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 294",
  d: "M384.797 451.507h-61.76a15 15 0 010-30h61.76a69.58 69.58 0 0069.5-69.5v-38.79a15 15 0 0130 0v38.79a99.613 99.613 0 01-99.5 99.5z",
  fill: "#e7f0ef"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 295",
  d: "M61.444 223c0 91.47 74.416 165.886 165.886 165.886L255.645 223 227.33 57.11c-91.472 0-165.886 74.416-165.886 165.89z",
  fill: "#e7f0ef"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 59"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 57"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 296",
  d: "M46.68 123.849a15 15 0 01-13.127-22.237 163.254 163.254 0 0163.827-64 15 15 0 0114.572 26.222 133.292 133.292 0 00-52.118 52.246 15 15 0 01-13.154 7.769z",
  fill: "#78e1fb"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 58"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 297",
  d: "M14.99 60.1A15 15 0 013.103 35.962 163.464 163.464 0 0137.29 2.827a15 15 0 1117.528 24.348 133.461 133.461 0 00-27.919 27.057A14.982 14.982 0 0114.99 60.1z",
  fill: "#78e1fb"
})))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 298",
  d: "M393.216 223c0-91.471-74.416-165.887-165.886-165.887v331.769c91.47 0 165.886-74.415 165.886-165.885z",
  fill: "#d8e6e8"
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 60"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 299",
  d: "M469.298 328.216a77.606 77.606 0 110-155.211 15 15 0 0115 15v125.212a15 15 0 01-15 15z",
  fill: "#d8e6e8"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 300",
  d: "M131.623 421.52a15 15 0 00-13.417 8.292l-30.031 60.062a15 15 0 0013.417 21.708h35.729l38.412-40.22 6.619-49.842z",
  fill: "#e7f0ef"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 301",
  d: "M366.485 489.874l-30.027-60.062a15 15 0 00-13.417-8.292h-50.733l-9.827 49.842 54.858 40.22h35.729a15 15 0 0013.417-21.708z",
  fill: "#d8e6e8"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 302",
  d: "M137.321 511.582h90.009l20.5-40.22-20.5-49.842h-44.978z",
  fill: "#e7f0ef"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 303",
  d: "M317.339 511.582l-45.031-90.062H227.33v90.062z",
  fill: "#d8e6e8"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 304",
  d: "M182.299 223a45.082 45.082 0 0045.031 45.031L247.539 223l-20.209-45.032A45.084 45.084 0 00182.299 223z",
  fill: "#f9f9f9"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 305",
  d: "M272.358 223a45.083 45.083 0 00-45.032-45.032v90.063A45.082 45.082 0 00272.358 223z",
  fill: "#e7f0ef"
})));
export default SvgRingsInside;